import ActivatePlan from "./ActivatePlan";

export default ActivatePlan;